/* eslint-disable import-extensions/file-extension-required */
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query, queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

import { preloadPersonalizedTemplatesV2OnboardingState } from './preloadPersonalizedTemplatesV2OnboardingState.ts';
import { preloadNthUserHomeOnboardingRevampState } from './nth-user-home-onboarding/preloadNthUserHomeOnboardingRevampState.ts';
import useGetTeamAndSubanchorGetPersonalSpaceKeyQuery, {
	type useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$data,
	type useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$variables,
} from './hooks/__generated__/useGetTeamAndSubanchorGetPersonalSpaceKeyQuery.graphql';
import PersonalizedTemplatesV2AllTemplatesQuery, {
	type PersonalizedTemplatesV2AllTemplatesQuery$data,
	type PersonalizedTemplatesV2AllTemplatesQuery$variables,
} from './__generated__/PersonalizedTemplatesV2AllTemplatesQuery.graphql';
import useGetTeamAndSubanchorGetSubanchorsAGGQuery, {
	type useGetTeamAndSubanchorGetSubanchorsAGGQuery$data,
	type useGetTeamAndSubanchorGetSubanchorsAGGQuery$variables,
} from './hooks/__generated__/useGetTeamAndSubanchorGetSubanchorsAGGQuery.graphql';
import useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery, {
	type useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$data,
	type useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$variables,
} from './hooks/__generated__/useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery.graphql';
import type { onboardingStateGetOnboardingStateQuery$data } from '@confluence/onboarding-helpers/entry-points/onboardingStateGetOnboardingStateQuery.ts';
import type { GraphQLError } from 'graphql';

export const preloadPersonalizedTemplates = (
	userId: string,
	accessStatus: AccessStatus,
): Promise<
	| void
	| Error[]
	| (
			| {
					data: onboardingStateGetOnboardingStateQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
			| {
					data: useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
			| {
					data: PersonalizedTemplatesV2AllTemplatesQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
			| {
					data: useGetTeamAndSubanchorGetSubanchorsAGGQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
			| {
					data: useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
	  )[]
> => {
	return waitForAllReturnWhenError([
		query<
			useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$data,
			useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$variables
		>({ query: useGetTeamAndSubanchorGetPersonalSpaceKeyQuery }),
		query<
			PersonalizedTemplatesV2AllTemplatesQuery$data,
			PersonalizedTemplatesV2AllTemplatesQuery$variables
		>({ query: PersonalizedTemplatesV2AllTemplatesQuery }),
		...(accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS
			? [
					queryAgg<
						useGetTeamAndSubanchorGetSubanchorsAGGQuery$data,
						useGetTeamAndSubanchorGetSubanchorsAGGQuery$variables
					>({
						query: useGetTeamAndSubanchorGetSubanchorsAGGQuery,
						variables: {
							accountId: userId || '',
						},
					}),
				]
			: []),
		...(accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS
			? [preloadPersonalizedTemplatesV2OnboardingState()]
			: []),
		preloadNthUserHomeOnboardingRevampState(),
		query<
			useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$data,
			useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$variables
		>({ query: useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery }),
	]);
};
